












import Vue from "vue";
import Mfa from "./partials/Mfa.vue";
import base64js from "base64-js";

export default Vue.extend({
  components: {
    Mfa,
  },
  data() {
    return {
      data: {},
      error: "",
    };
  },
  methods: {
    bufferEncode(value) {
      return base64js
        .fromByteArray(value)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
    },
    bufferDecode(value) {
      return Uint8Array.from(atob(value), (c) => c.charCodeAt(0));
    },
    buffer2string(buf) {
      let str = "";
      if (!(buf.constructor === Uint8Array)) {
        buf = new Uint8Array(buf);
      }
      buf.map((x) => {
        return (str += String.fromCharCode(x));
      });
      return str;
    },
    async onReady(data, onReadyToSubmit, submit) {
      try {
        if (!window.PublicKeyCredential) {
          throw new Error("Current platform not support");
        }

        const response = JSON.parse(data.data);
        const payload = JSON.parse(response.payload);
        payload.publicKey.challenge = this.bufferDecode(
          payload.publicKey.challenge
        );

        if (!response.ready) {
          payload.publicKey.user.id = this.bufferDecode(
            payload.publicKey.user.id
          );
          if (payload.publicKey.excludeCredentials) {
            payload.publicKey.excludeCredentials.forEach((listItem) => {
              listItem.id = this.bufferDecode(listItem.id);
            });
          }
          if (payload.publicKey.rp) {
            payload.publicKey.rp.id = document.domain;
          }
          if (payload.publicKey.rpId) {
            payload.publicKey.rpId = document.domain;
          }

          const credentialRaw = await navigator.credentials.create(payload);
          const credential = credentialRaw as any;

          onReadyToSubmit({
            custom_payload: JSON.stringify({
              id: credential.id,
              rawId: this.bufferEncode(new Uint8Array(credential.rawId)),
              type: credential.type,
              response: {
                attestationObject: this.bufferEncode(
                  new Uint8Array(credential.response.attestationObject)
                ),
                clientDataJSON: this.bufferEncode(
                  new Uint8Array(credential.response.clientDataJSON)
                ),
              },
            }),
          });
          submit();
        } else {
          payload.publicKey.allowCredentials.forEach((listItem) => {
            listItem.id = this.bufferDecode(listItem.id);
          });

          const credentialRaw = await navigator.credentials.get(payload);
          const credential = credentialRaw as any;

          onReadyToSubmit({
            custom_payload: JSON.stringify({
              id: credential.id,
              rawId: this.bufferEncode(new Uint8Array(credential.rawId)),
              type: credential.type,
              response: {
                authenticatorData: this.bufferEncode(
                  new Uint8Array(credential.response.authenticatorData)
                ),
                clientDataJSON: this.bufferEncode(
                  new Uint8Array(credential.response.clientDataJSON)
                ),
                signature: this.bufferEncode(
                  new Uint8Array(credential.response.signature)
                ),
                userHandle: this.bufferEncode(
                  new Uint8Array(credential.response.userHandle)
                ),
              },
            }),
          });
          submit();
        }
      } catch (e) {
        console.log(e);
        this.error = e;
      }
    },
  },
  created() {},
});
